import i18n from "~/i18n";

export const hasCustomPermission = (user, customPermission) => {
  const customPermissions = user?.custom_permissions || [];
  return customPermissions.some((value) => value === customPermission);
};

export const userTypes = ["Owner", "Member", "Client"];

export const isOwner = (user) => user?.class?.toLowerCase() === "owner";

export const isMember = (user) => user?.class?.toLowerCase() === "member";

export const isClient = (user) => user?.class?.toLowerCase() === "client";

export const isArchived = (user) => user?.is_archived;

export const isVirtual = (user) => user?.is_email_at_example;

export const isPowerClient = (user) => {
  return isClient(user) && hasCustomPermission(user, "can_manage_tasks");
};

export const isPowerUser = (user) => {
  return isOwner(user) || (isMember(user) && hasCustomPermission(user, "can_manage_projects"));
};

export const isFinancialManager = (user) => {
  return isOwner(user) || (isMember(user) && hasCustomPermission(user, "can_manage_finances"));
};

export const isMemberWithoutPermissions = (user) => {
  return (
    isMember(user) &&
    !hasCustomPermission(user, "can_manage_finances") &&
    !hasCustomPermission(user, "can_manage_projects")
  );
};

export const isMemberFinancialManager = (user) => {
  return isMember(user) && hasCustomPermission(user, "can_manage_finances");
};

export const resolvedUserDetails = (user, forArchive = false) => {
  let resolvedArchivedVirtualUserRole = "";
  let resolvedArchivedVirtualUserColor = "";
  if (isArchived(user) && !forArchive) {
    resolvedArchivedVirtualUserRole = i18n.t(`Archived`);
    resolvedArchivedVirtualUserColor = "#DDDDDD";
  }

  if ((isVirtual(user) && !isArchived(user)) || (isVirtual(user) && forArchive)) {
    resolvedArchivedVirtualUserRole = i18n.t(`Virtual`);
    resolvedArchivedVirtualUserColor = "#CACACA";
  }

  const isManagingProjects = hasCustomPermission(user, "can_manage_projects");
  const isManagingFinances = hasCustomPermission(user, "can_manage_finances");
  const tooltipText = isManagingProjects
    ? isManagingFinances
      ? i18n.t("Managing projects and finances")
      : i18n.t("Managing projects")
    : isManagingFinances
    ? i18n.t("Managing finances")
    : null;

  if (isOwner(user)) {
    return {
      role: `${resolvedArchivedVirtualUserRole} ${i18n.t("Owner")}`,
      color: resolvedArchivedVirtualUserColor ? resolvedArchivedVirtualUserColor : "#A3CDFF",
      tooltip: null,
    };
  }
  if (isMember(user)) {
    const baseRole = i18n.t("Member");
    const roleSuffix = isManagingProjects || isManagingFinances ? "+" : "";
    const role = `${resolvedArchivedVirtualUserRole} ${baseRole}${roleSuffix}`;
    const defaultColor = isManagingProjects || isManagingFinances ? "#FF9C9C" : "#EAC2AD";
    const color = resolvedArchivedVirtualUserColor ? resolvedArchivedVirtualUserColor : defaultColor;

    return { role, color, tooltip: tooltipText };
  }

  if (isPowerClient(user)) {
    return {
      role: `${resolvedArchivedVirtualUserRole} ${i18n.t("Client")}+`,
      color: resolvedArchivedVirtualUserColor ? resolvedArchivedVirtualUserColor : "#FDF196",
      tooltip: i18n.t("Can be assigned to tasks"),
    };
  }

  return {
    role: `${resolvedArchivedVirtualUserRole} ${i18n.t("Client")}`,
    color: resolvedArchivedVirtualUserColor ? resolvedArchivedVirtualUserColor : "#FFCC6B",
    tooltip: null,
  };
};
